export const LocalStorageKeys = {
	locale: "locale",
	notifications: "notifications",
	featureToggles: "featureToggles",
	serverConfiguration: "serverConfiguration",
	targetInfrastructureId: "targetInfrastructureId",
	translations: "translations",
	legalContent: "legalContent",
};
